import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './styles.css'

const SectionIntegrationSlide = ({ img, text, small }) => {
  return (
    <div className={classNames({
      'w-50 w-third-m mb3 mb0-m ph2 flex': true,
      'flex-column items-center justify-end': true
    })}>
      <img
        className={classNames({
          'mb3 w-100': true,
          'mw180': small,
          'mw240': !small
        })}
        src={img}
        alt={text}
      />
      <p className="f13 ttu mb0 min-h30 first-letter gray">
        {text}
      </p>
    </div>
  )
}

SectionIntegrationSlide.propTypes = {
  text: PropTypes.string,
  small: PropTypes.bool
}

export default SectionIntegrationSlide



// WEBPACK FOOTER //
// ./src/components/section-integration/section-integration-slide.js